import { FocusRoot } from '@please/lrud'
import styled from 'styled-components'

export const ErrorContainer = styled(FocusRoot)`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-content: center;
`
export const ErrorWrapper = styled('div')`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  text-align: center;

  p {
    padding-bottom: 2rem;
  }
`
